import { APICore } from 'helpers/api/apiCore'

const api = new APICore()

export function atualizaToken(token: string, usuarioInstituicao: string) {
  return api.create(`Credencial/token`, {
    token,
    usuarioInstituicao
  })
}

export function getUsuariosInstituicao() {
  return api.get(`Credencial/usuario-instituicao-bmg`, null)
}

export function associarRamal() {
  return api.create(`IntegracaoTelecom/associar`, null)
}

export function desassociarRamal() {
  return api.create(`IntegracaoTelecom/desassociar`, null)
}

export function getRamalAssociado() {
  return api.get(`IntegracaoTelecom/ramal`, null)
}

export function getMotivosPausa() {
  return api.get(`IntegracaoTelecom/pausas`, null)
}

export function pausarAgente(identificador: string) {
  return api.create(`IntegracaoTelecom/pausar`, {
    identificador
  })
}

export function despausarAgente() {
  return api.create(`IntegracaoTelecom/despausar`, null)
}

export function getStatusAgente() {
  return api.get(`IntegracaoTelecom/status-agente`, null)
}
